import { __decorate } from "tslib";
import * as React from 'react';
import warning from 'choerodon-ui/lib/_util/warning';
import { observer } from 'mobx-react';
import omit from 'lodash/omit';
import Base from './Base';
import { FormField } from '../field/FormField';
let Text = class Text extends FormField {
    get mergedEllipsis() {
        const { ellipsis } = this.props;
        if (ellipsis && typeof ellipsis === 'object') {
            return omit(ellipsis, ['expandable', 'rows']);
        }
        return ellipsis;
    }
    renderWrapper() {
        const { ellipsis, children, ...restProps } = this.props;
        warning(typeof ellipsis !== 'object' ||
            !ellipsis ||
            (!('expandable' in ellipsis) && !('rows' in ellipsis)), 'Typography.Text `ellipsis` do not support `expandable` or `rows` props.');
        return (React.createElement(React.Fragment, null,
            React.createElement(Base, Object.assign({}, restProps, { ellipsis: this.mergedEllipsis, component: "span" }), this.processRenderer(this.getValue()) || children),
            this.renderFloatLabel()));
    }
};
Text.displayName = 'Text';
Text.__PRO_TEXT = true;
Text.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'text',
};
Text = __decorate([
    observer
], Text);
export default Text;
